export default "__VITE_ASSET__f1f4a9b9__$_?nuxt_component=async&nuxt_component_name=SvgoPrev__"